export class EventoAdversoModel {
    nome_relator: string;
    email_relator: string;
    telefone_relator: string;
    nome_paciente: string;
    sexo_paciente: string;
    peso_paciente: string;
    altura_paciente: string;
    idade_paciente: string;
    email_paciente: string;
    telefone_paciente: string;
    produto: string;
    lote: string;
    indicação: string;
    evento_adverso: string;
    descricao_evento: string;
    data_inicio: string;
    data_termino: string;
    continua: string;
    evento_tratado: string;
    suspenso_medicamento: string;
    doenca_paciente: string;
    medicamento_paciente: string;
    crm_medico: string;
    nome_medico: string;
    especialidade_medico: string;
    telefone_medico: string;
    especialidades: Array<string>;
    estados: Array<string>;
    estado: string;
    produtos: Array<string>;
}


// WEBPACK FOOTER //
// ./src/pages/evento-adverso/evento-adverso.modelview.ts